import { createContext, useContext } from 'react'

// Context for compound component pattern
export const SearchContainerContext = createContext<{
  containerId: string
} | null>(null)

// Hook to use container context
export const useSearchContainer = () => {
  const context = useContext(SearchContainerContext)
  if (!context) {
    throw new Error('useSearchContainer must be used within SearchContainer')
  }
  return context
}
